module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30bbb9d3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 1568
// module chunks = 50